export function Footer() {
  return (
    <footer className="w-full h-14 bg-gray-800 text-white grid">
      <p className="place-self-center">Copyright &copy; Enkeldrift AS</p>
    </footer>
  );
}
